console.log("cart.js");

  $(function(){
  	var processCheckOut = false;
  	var processUpdateCart = false;

    function update(next){
      if(!processUpdateCart){

        /* not used in this theme

        processUpdateCart = true;

        var isUpdateRequired = false;
        var postObject = {"updates":[]};

        if($("#cartform").find("input.cart-qty").length>0){
          isUpdateRequired = true;
          $("#cartform").find("input.cart-qty").each(function(index,element){
            postObject.updates.push(+$(element).val());
          });
        }

        postObject.note= $("#note").val();

        if(isUpdateRequired){
          jQuery.post('/cart/update.js', postObject)
          .done(function(res){
            if(next){
              next();
            }
            else{
              location.reload();
            }
          })
          .catch(function(err){
            alert("Something is wrong.. Please empty cart and retry");
            location.reload();
          });
        }

        */
        next();

      }
    }

    function checkoutAndSubmit($button){
      if(!processCheckOut){
        processCheckOut = true;

        var isUpdateRequired = false;
        var postObject = {"updates":{}};

        window.IMTK.shopify.cart.items.forEach(function(item){
          if(item.properties && item.properties._variantIds){
          	isUpdateRequired = true;

            var variantIds = item.properties._variantIds.split(",");
            variantIds.forEach(function(variantId){
              if(postObject.updates[+variantId]){
                postObject.updates[+variantId] += item.quantity;
              }else{
                postObject.updates[+variantId] = item.quantity;
              }
            });
          }
        });
        
        if(isUpdateRequired){
          jQuery.post('/cart/update.js', postObject)
          .done(function(res){
            processCheckOut = false;
            $("#cartform").find("input.cart-qty").attr("disabled","disabled");
            if($button){
                $button.trigger("click");
            }
          })
          .catch(function(err){
            alert("Something is wrong.. Please empty cart and retry");
            location.reload();
          });
        } else if($button){
          $button.trigger("click");
        }

      }
    }

    function initTotalPrice(){
      var totalPrice = 0;
      $("span[data-price]").each(function(index,element){
        totalPrice += (+$(element).data("price"));
      });
      $("#imtk_cart_subtotal").html("$ " + (totalPrice/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
      $("#imtk_cart_subtotal").removeClass("imtk_hidden");
    }

    function initAdditionalCheckOutButtons(){
      
      $('.additional-checkout-buttons .dynamic-checkout__content').hide();
      
      var cart;
      if(window.IMTK && window.IMTK.shopify && window.IMTK.shopify.cart){
        cart = window.IMTK.shopify.cart;
      }

      if(cart){
        var optionDetected = false;

        cart.items.forEach(function(item){
          if(item.product_type == "OPTIONS_HIDDEN_PRODUCT"){
            isUpdateRequired = true;
            postObject.updates[+item.variant_id] = 0;
          }
          if(item.properties && Object.keys(item.properties).length) optionDetected = true;
        });

        if(!optionDetected) {
        	$('.additional-checkout-buttons .dynamic-checkout__content').show();
        }
        else {
          var $clonedButtonsContainer = $('<div></div>');
          var $loading = $('<div>loading additional payment options...</div>');
          $clonedButtonsContainer.insertBefore('.additional-checkout-buttons .dynamic-checkout__content');
          $loading.appendTo($clonedButtonsContainer);
          
          var intervalId = setInterval(function(){
            var loaded = $('.dynamic-checkout__content').text();
            
            if(loaded) {
              clearInterval(intervalId);
            
              var $targetButtons = $(".additional-checkout-buttons button[type='submit'], .additional-checkout-buttons a, .additional-checkout-buttons [role='button']");
              var $clonedButtons = $targetButtons.clone();

              //$('.additional-checkout-buttons .dynamic-checkout__content').show();
              //$('.additional-checkout-buttons .dynamic-checkout__content .shopify-cleanslate').hide();
              $loading.hide();

              $clonedButtons.each(function(index,element){
                $(element).attr("type","button");
                $(element).attr("class",$(element).attr("class")+" _cloned");
              });
              $clonedButtons.appendTo($clonedButtonsContainer).wrap('<div class="shopify-cleanslate" style="margin-bottom:8px;"></div>');

              $clonedButtons.on("click",function(){
                var targetClass = $(this).attr("class").replace(" _cloned","");
                var $target = $("[class='"+targetClass+"']");
                update(function(){checkoutAndSubmit($target)});
              });
              
            }
            
          },500);

    //       $paypalBtn = $(".additional-checkout-button--paypal");
    //       if($paypalBtn.length>0){
    //         $paypalCover = $(`<div style="position:absolute;width:100%;height:100%;left:0;top:0;z-index:10000;cursor:pointer;"></div>`);
    //         $paypalBtn.css("position","relative").append($paypalCover)
    //         $paypalCover.on("click",function(){
    //           update(function(){checkoutAndSubmit()});
    //           $(this).remove();
    //         });
    //       }
        }
      }
    }

    function init(){
      initTotalPrice();
      initAdditionalCheckOutButtons();
    }

    init();

    $("#imtk_checkout").on("click",function(e){
      e.preventDefault();
      var self = this;
      update(function(){checkoutAndSubmit($("#checkout"))});
    });

    $(".js-change-quantity").on("click", function(){
      $("#imtk_cart_subtotal").parent().parent().hide();
    });

    /* not used in this theme

    $(".cart-remove").on("click",function(){
      $(this).closest("tr").find("input.cart-qty").val(0);
      $('#imtk_update_cart').trigger("click");
    });

    $("#imtk_update_cart").on("click",function(){
      update();
    });

    $(".cart-qty").on("change",function(){
      var index = $(".cart-qty").index($(this));
      var value = $(this).val();
      window.IMTK.shopify.cart.items[index].quantity = +value;
    });

    */

  });
